import type { WidenMediaElement } from '@libs/widen-utils';
import type { JsonLdProductFragmentEnhanced, ProductFragmentEnhanced } from '@models/enhanced-fragments';
import { ProductHelper } from '@models/graphql';

export const getProductImages = (
  allProducts: (ProductFragmentEnhanced | JsonLdProductFragmentEnhanced)[],
  locale?: string
) =>
  allProducts.reduce((images: Record<string, WidenMediaElement[]>, currentProduct) => {
    const result = { ...images };
    const { productMedia } = ProductHelper.getAssetsMedia(currentProduct, undefined, locale);
    result[currentProduct.id] = productMedia.filter((image, idx, mediaArray) => {
      if (mediaArray.findIndex(currentImage => image.widenId === currentImage.widenId) === idx) {
        return true;
      }
      return false;
    });
    return result;
  }, {});
